<template>

    <i class="arrow" :class="direction" />

</template>

<style scoped lang="scss">

    .arrow {
        border: solid $color-text;
        border-width: 0 2px 2px 0;
        display: inline-block;
        opacity: 0.5;
        padding: 3px;
        &.right {
            transform: rotate(-45deg);
        }
        &.left {
            transform: rotate(135deg);
        }
        &.up {
            transform: rotate(-135deg);
        }
        &.down {
            transform: rotate(45deg);
        }
    }

</style>

<script>

export default {

    props: {
        direction: {
            type: String,
            default: 'down',
        },
    },

}

</script>
